if (!customElements.get('collection-count')) {
    class CollectionCount extends ErpConnection {

        constructor() {
            super();
            this.id = this.dataset.collectionId;
            this.handle = this.dataset.handle;
            this.count = 0;
        }
        
        connectedCallback() {
            this.init();
        }

        async init() {
            this.count = await this.getCount();
            if (this.count > 0) {
                this.closest('li').classList.remove('hidden');
            }
        }

        async getCount() {
            const response = await fetch(`/collections/${this.handle}?view=json`);
            const json = await response.json();
            return json.count;
        }
    }
    
    customElements.define('collection-count', CollectionCount);
}